export function pingToReactNativeWebview(type = "DEFAULT", payload = {} ){
	if(window.ReactNativeWebView?.postMessage){
		let postMessageData = {
			type: type, 
			payload: payload
		}	

		window.ReactNativeWebView.postMessage(JSON.stringify(postMessageData))
	}
}